export default __webpack_public_path__ + "static/media/gallery-wip-emitter-shroud_06.2d197520.jpg";